<template>
  <div class="box c-p-lr-20" v-if="nameList.length > 1">
    <div class="r c-m-r-20">
      <van-dropdown-menu>
        <van-dropdown-item
          @change="changeId"
          v-model="value1"
          :options="nameList"
          title-class="vpn_title"
        >
        </van-dropdown-item>
      </van-dropdown-menu>
    </div>
  </div>
</template>

<script>
import { handleSessionStorage, handleLocalStorage } from "@/utils/index";
export default {
  name: "SelectStoreEntrance",
  props: {},
  data() {
    return {
      searchVal: "",
      // userAvatarImg: require("@/assets/images/Headportrait@2x.png"),
      changeImg: require("@/assets/images/icon-qihuan.png"),
      nameList: [],
      value1: "",
    };
  },
  created() {
    this.$nextTick(() => {
      this.init();
    });
  },
  mounted() {},
  methods: {
    onSearch() {},
    onCancel() {},
    toCenter() {
      this.$router.push("/personCenter/index");
    },
    init() {
      const _this = this;
      if (localStorage.getItem("allStoreList")) {
        handleSetVpn();
      } else {
        window.addEventListener("setItem", () => {
          console.log("切换门店更新~~~~~~~~~~~~~");
          handleSetVpn();
          //   let doorInfo = JSON.parse(localStorage.getItem("websocketHistory"));
          //   if (doorInfo && doorInfo.length !== 0) {
          //     this.nameList = doorInfo.map((v) => {
          //       let obj = {};
          //       obj.text = v.Name;
          //       obj.value = v.Id;
          //       obj.code = v.SaaSCode;
          //       obj.payType = v.SaasVpnSetting.WechatPayChannel;
          //       return obj;
          //     });
          //     // let getVpnId = this.$pub.getS('vpnId');
          //     let getVpnId = this.$store.state.vpnId;
          //     const vpnItem = this.nameList.find((v) => {
          //       return v.value === getVpnId;
          //     });
          //     if (getVpnId && vpnItem) {
          //       this.value1 = vpnItem.value;
          //     } else {
          //       this.value1 = this.nameList[0].value;
          //       this.$store.commit("set_vpnid", this.value1);
          //       this.$store.commit("set_vpnInfo", {
          //         name: this.nameList[0].text,
          //         code: this.nameList[0].code,
          //         payType: this.nameList[0].payType,
          //       });
          //     }

          //     this.$emit("sendVpnId", this.value1);
          //   }
        });
      }
      function handleSetVpn() {
        const vpnListArr = JSON.parse(localStorage.getItem("allStoreList"));

        let getVpnId = _this.$store.state.vpnId;
        console.log("handleSetVpn", getVpnId);
        if (vpnListArr) {
          _this.nameList = vpnListArr.map((v) => {
            let obj = {};
            obj.text = v.Name;
            obj.value = v.Id;
            obj.code = v.SaaSCode;
            obj.payType = v.SaasVpnSetting.WechatPayChannel;
            obj.SaasVpnSetting = v.SaasVpnSetting;
            obj.Claims = v.Claims;
            return obj;
          });
          const vpnItem = _this.nameList.find((v) => {
            return v.value === getVpnId;
          });
          if (getVpnId && vpnItem) {
            _this.value1 = vpnItem.value;
          } else {
            _this.value1 = _this.nameList[0].value;
          }
          _this.$emit("sendVpnId", _this.value1);
        }
      }
    },

    // 门店切换。 将goodsCache购物车数据清空
    changeId(val, idx) {
      console.log("11111<<<  val  >>>11111");
      console.log(val);
      console.log("22222<<<  idx  >>>22222");
      console.log(idx);
      let vpnId = val;
      this.$emit("sendVpnId", vpnId);
      // this.$pub.setS('vpnId', vpnId);
      this.$store.commit("set_vpnid", vpnId);
      const vpnItem = this.nameList.find((item) => item.value == val);
      this.$store.commit(
        "set_vpnInfo",
        vpnItem
          ? {
              name: vpnItem.text,
              code: vpnItem.code,
              payType: vpnItem.payType,
              Claims: vpnItem.Claims,
              ...vpnItem.SaasVpnSetting,
            }
          : { name: "", code: "", payType: null, Claims: [] }
      );
      localStorage.setItem("store", JSON.stringify(this.$store.state));
      this.$pub.clearS("goodsCache");
    },

    toTest() {
      if (this.$root.isDev) {
        this.$router.push("/test/test1");
      }
    },
    toGoodsSearch() {
      this.$router.push("/homePage/goodsSearch");
    },
  },
};
</script>
<style scoped lang="scss">
.box {
  /* padding: 10px; */
  // height: 80px;
  background: #fff;
}
::v-deep .vpn_title {
  width: 100%;
}
.toGoodsSearch {
  width: 100%;
  border-radius: 30px;
}
.photo {
  width: 56px;
  height: 56px;
  border-radius: 50%;
}
.txt {
  font-size: 26px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #333333;
}
.change-img {
  width: 26px;
  height: 22px;
  padding-left: 10px;
}
</style>
